<script>
import { h } from 'vue';

export default {
  name: 'cGridView',
  data() {
    return {};
  },
  props: {
    cols: {
      type: Number,
      default: 2
    }
  },
  provide() {
    return { parentsCols: this.cols };
  },
  methods: {},
  render() {
    const { cols } = this;

    return h(
      'div',
      {
        class: {
          'c-grid-view': true
        }
      },
      [h('div', {}, [this.$slots.default()])]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-grid-view {
  overflow: hidden;
  > div {
    display: flex;
    flex-wrap: wrap;
    margin-left: -35px;
    margin-right: -35px;
    margin-top: -10px;
    margin-bottom: -10px;
  }
}
</style>
